import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authenticate, logout } from "@/api";

export const useAuthClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (didToken: string) => authenticate(didToken),
    
    onSuccess: (user, variables) => {
      queryClient.setQueryData(["user"], user);
      queryClient.invalidateQueries({ queryKey: ["didToken", variables] });
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return logout();
    },
    onSuccess: async () => {
      queryClient.setQueryData(["user"], null);
      await queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
};